module.exports = __webpack_public_path__ + "static/footer-exa-team-es-7fe4ac72fc2b2e35ccaf49980bc82b97.png";